import useAxios from 'hooks/useAxios';

export async function deleteAvatar(id) {
  const api = useAxios();

  try {
    const res = await api.delete(`/avatars/${id}`);
    return res;
  } catch (err) {
    return err;
  }
}
